import { CartState } from '../Reducers/Cart.reducer';
import { Order } from '../Types/Order';
import Product from '../Types/Product';
import {
  adformServiceAddToWishListEvent,
  adformServiceNewsLetterEvent,
  adformServicePurchaseEvent,
  adformServiceViewContentProductPageEvent,
} from './Adform.service';
import {
  dataLayerAddToWishlist,
  dataLayerNewsLetterSignUp,
  mapProductToGtmItem,
} from './Gtm.service';
import {
  metaServiceAddToWishListEvent,
  metaServiceInitiateCheckoutEvent,
  metaServiceNewsLetterEvent,
  metaServicePurchaseEvent,
} from './Meta.service';
import {
  pinterestServiceInitiateCheckoutEvent,
  pinterestServiceNewsLetterEvent,
  pinterestServicePurchaseEvent,
  pinterestServiceSearchEvent,
} from './Pinterest.service';

export const trackingServiceAddToWishListEvent = (
  product: Product,
  currency: string
) => {
  metaServiceAddToWishListEvent(product);
  adformServiceAddToWishListEvent(product);
  dataLayerAddToWishlist(
    [mapProductToGtmItem(product, { quantity: 1 })],
    currency
  );
};

export const trackingServiceInitiateCheckoutEvent = (cart: CartState) => {
  pinterestServiceInitiateCheckoutEvent(cart);
  metaServiceInitiateCheckoutEvent(cart);
};

export const trackingServicePurchaseEvent = (order: Order) => {
  metaServicePurchaseEvent(order);
  pinterestServicePurchaseEvent(order);
  adformServicePurchaseEvent(order);
};

export const trackingServiceNewsLetterEvent = (currency: string) => {
  metaServiceNewsLetterEvent();
  pinterestServiceNewsLetterEvent();
  adformServiceNewsLetterEvent(currency);
  dataLayerNewsLetterSignUp();
};

export const trackingServiceSearchEvent = (query) => {
  pinterestServiceSearchEvent(query);
};

export const trackingServiceProductPageViewEvent = (currency: string) => {
  adformServiceViewContentProductPageEvent(currency);
};
